import React, { FC } from 'react';

import { ImageComponent } from '../Image';

import { ScBadge } from './styled';

type BadgeType = 'top' | 'new' | 'jackpot' | 'trending';

const MAP_CATEGORY_TO_ICON = {
  top: { src: '/topIcon.webp' },
  new: { src: '/newIcon.webp' },
  jackpot: { src: '/jackpotIcon.webp' },
  trending: { src: '/trendingIcon.webp' },
};

interface IBadgeProps {
  type: BadgeType;
}

const Badge: FC<IBadgeProps> = ({ type }) => {
  return (
    <ScBadge>
      <ImageComponent
        width={24}
        height={24}
        src={MAP_CATEGORY_TO_ICON[type].src}
        alt="badge"
        loading="eager"
      />
    </ScBadge>
  );
};

export default Badge;
